﻿export function readFileAsTextAsync(file: File):Promise<string> {
    return new Promise<string>((resolve, reject) => {        
        const reader = new FileReader();
        reader.onload = () => {
            if (typeof reader.result === 'string') resolve(reader.result);
            else reject(new Error('FileReader did not produce text.'));
        };
        reader.onerror = () => reject(reader.error ?? new Error('Cannot read file as text.'));
        reader.readAsText(file);
    });
}

export function readAsDataURLAsync(file: File):Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (typeof reader.result === 'string') resolve(reader.result);
            else reject(new Error('FileReader did not produce a data URL.'));
        };
        reader.onerror = () => reject(reader.error ?? new Error('Cannot read file as a data URL.'));
        reader.readAsDataURL(file);
    });
}

export function readAsArrayBufferAsync(file: File):Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.result instanceof ArrayBuffer) resolve(reader.result);
            else reject(new Error('FileReader did not produce an ArrayBuffer.'));
        };
        reader.onerror = () => reject(reader.error ?? new Error('Cannot read file as an ArrayBuffer.'));
        reader.readAsArrayBuffer(file);
    });
}

export function readAsImgAsync(file: File): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        if (!file.type.match(/^image\//)) {
            reject(new Error('File is not an image.'));
            return;
        }
        const reader = new FileReader();
        reader.onerror = () => reject(reader.error ?? new Error('Cannot read image file.'));
        reader.onload = function () {
            if (typeof reader.result !== 'string') {
                reject(new Error('FileReader did not produce an image data URL.'));
                return;
            }
            const image = new Image();
            image.onload = function () { resolve(image); }
            image.onerror = () => reject(new Error('Cannot decode image file.'));
            image.src = reader.result;
        }
        reader.readAsDataURL(file);
    });
}
